import { gql } from '@apollo/client';

export const CREATE_CONVERSATION = gql`
    mutation createConversation($input: UpdateStyleConversationInput!) {
        conversation(input: $input) {
            id
            chatbotProfileId
            userId
            recommendedElements {
                role
                content
                dynamicContent
                visible
                scope
                created
                answer
                taffiId
                type
                required
                i18n
                language
                elements {
                    template
                    type
                    label
                    dynamicLabel
                    value
                    url
                    message
                    productId
                    productType
                    productTaffiId
                    stylistId
                    stylistEmail
                    stylistFirstName
                    stylistLastName
                    collectionName
                    functionName
                    labelI18n
                    messageI18n
                    storeProductId
                    storeIds
                    labels {
                        id
                        name
                    }
                    items {
                        id
                        creator
                        price
                        currency
                        storeUrl
                        taffiId
                        taffiUrl
                        title
                        category
                        images
                        style_image
                        image_metadata
                        storeProductId
                        backgroundRemovedMap {
                            backgroundRemovedUrl
                            originalUrl
                            width
                            height
                            xmin
                            xmax
                            ymin
                            ymax
                        }
                        store {
                            id
                            taffiId
                            name
                            url
                            shopifyDomain
                            platform
                        }
                    }
                    imageJson
                }
            }
            messages {
                id
                role
                content
                dynamicContent
                visible
                scope
                created
                answer
                feedbackReason
                conversationId
                taffiId
                type
                required
                i18n
                language
                elements {
                    template
                    type
                    label
                    dynamicLabel
                    value
                    url
                    message
                    productId
                    productType
                    productTaffiId
                    stylistId
                    stylistEmail
                    stylistFirstName
                    stylistLastName
                    collectionName
                    functionName
                    labelI18n
                    messageI18n
                    storeProductId
                    storeIds
                    labels {
                        id
                        name
                    }
                    items {
                        id
                        creator
                        price
                        currency
                        storeUrl
                        taffiId
                        taffiUrl
                        title
                        category
                        images
                        style_image
                        image_metadata
                        storeProductId
                        backgroundRemovedMap {
                            backgroundRemovedUrl
                            originalUrl
                            width
                            height
                            xmin
                            xmax
                            ymin
                            ymax
                        }
                        store {
                            id
                            taffiId
                            name
                            url
                            shopifyDomain
                            platform
                        }
                    }
                    imageJson
                }
            }
            language
            status
            gender
            birthday
            created
            creator
            updated
            updater
        }
    }
`;

export const UPDATE_STYLE_MESSAGE = gql`
    mutation updateStyleMessage($input: UpdateStyleMessageInput!) {
        updateStyleMessage(input: $input) {
            id
            role
            content
            dynamicContent
            visible
            answer
            taffiId
            type
        }
    }
`;
